var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60359 2.5898C9.58156 2.55025 9.55374 2.51306 9.52014 2.47945C9.41997 2.37929 9.28787 2.3305 9.1566 2.33311L3.5 2.33309C3.22386 2.33309 3 2.55694 3 2.83309C3 3.10923 3.22385 3.33309 3.5 3.33309L7.95938 3.3331L2.4797 8.81279C2.28444 9.00805 2.28444 9.32463 2.4797 9.51989C2.67496 9.71516 2.99154 9.71516 3.18681 9.51989L8.66668 4.04002V8.49976C8.66668 8.7759 8.89054 8.99975 9.16668 8.99975C9.44282 8.99975 9.66668 8.7759 9.66668 8.49976V2.83311C9.66668 2.74478 9.64378 2.66181 9.60359 2.5898Z",
    fill: "#212124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon_arrow.8a00f553ef47df2cb7e82d16cd04458b.svg";
export { ForwardRef as ReactComponent };